import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import ExamService from '../../services/exam.service';
import toast from 'react-hot-toast';

interface IUploadUserSheetModal {
  show: boolean;
  handleClose: any;
  onUploadSuccess?: any
  uploading?: boolean;
}

const UploadReverificationSheetModal = ({ show, handleClose, onUploadSuccess, uploading }: IUploadUserSheetModal) => {

  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length) {
        const file = acceptedFiles[0];
        setSelectedFile(file);
        onUploadSuccess(file);
      }
    },
    [show]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'text/csv': ['.csv'] },
    multiple: false,
  });

  console.log("show", show);

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
      <Modal.Body>
        <div
          {...getRootProps()}
          className={`border border-2 rounded p-4 text-center ${isDragActive ? 'bg-light' : ''}`}
          style={{ cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.6 : 1 }}
        >
          <input {...getInputProps()} disabled={uploading} />
          <FontAwesomeIcon icon={faUpload} size="3x" className="mb-3 text-primary" />
          <p className="fw-bold">
            {uploading ? 'Uploading file...' : 'Drag and drop a file here, or click to select'}
          </p>
          <small className="text-muted">Supported format: .csv</small>

          {selectedFile && (
            <div className="mt-3">
              <FontAwesomeIcon icon={faFileAlt} className="me-2 text-success" />
              <span className="text-success">{selectedFile.name}</span>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={uploading}>
          {uploading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Uploading...
            </>
          ) : (
            'Close'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadReverificationSheetModal;
